import { ColorOptions, MaterialTextInput, MaterialTextInputProps } from '@jfs/ui-new'
import { refundTheme } from '../../util/customTheme'

interface AepsTextInputProps extends MaterialTextInputProps {
  textType?: 'nameWithSpace' | 'captialize' | 'numOnly'
}

export const AepsTextInput = (props: AepsTextInputProps) => {
  return (
    <MaterialTextInput
      tintColor={refundTheme.colors.PRIMARY as ColorOptions}
      bottomLineColor={refundTheme.colors.PRIMARY as ColorOptions}
      color={'BRAND_COLOR_GRAY_1'}
      fontSize={16}
      {...props}
      onChange={(text: string) => {
        if (props.textType === 'nameWithSpace') {
          if (text.trim().length === 0) {
            text = text.trim()
          } else if (
            ['  ', '..', "''", ".'", '. ', "' ", "'.", ' .', " '"].includes(text.slice(-2)) ||
            !text.match(/^[a-zA-Z]+(\s{0,1}[a-zA-Z'. ])*$/)
          ) {
            text = text.slice(0, text.length - 1)
          }
        } else if (props.textType === 'captialize') {
          text = text.toUpperCase()
        } else if (props.textType === 'numOnly' && !/^\d+$/.test(text)) {
          text = text.slice(0, text.length - 1)
        }
        props.onChange?.call(this, text)
      }}
    />
  )
}
